import { css } from '@emotion/react';
import { Breakpoint } from '../../hooks/use-container-breakpoints';
export const formContainerStyles = css({
  display: 'flex',
  justifyContent: 'flex-start',
  flex: 1,
  alignItems: 'flex-start'
});
export const formStyles = breakpoint => css({
  // by default, form elements seem to pick up 12px
  // top margin so we clear it
  margin: 0,
  flex: 1,
  justifyContent: 'left',
  display: breakpoint <= Breakpoint.Small ? 'block' : 'flex',
  alignItems: 'flex-start',
  '&[data-layout="column"]': {
    flexDirection: 'column',
    rowGap: "var(--ds-space-100, 8px)",
    '> *': {
      width: '100%'
    }
  }
});
export const formInnerStyles = css({
  display: 'flex',
  flex: 1,
  "&[data-multiline='true']": {
    display: 'block'
  }
});
export const buttonWrapperStyles = css({
  float: 'right',
  display: 'flex',
  "&[data-multiline='true']": {
    paddingTop: "var(--ds-space-100, 8px)"
  }
});
export const logoContainerStyles = breakpoint => css({
  display: 'flex',
  flexDirection: 'row',
  marginRight: "var(--ds-space-050, 4px)",
  alignItems: 'center',
  alignSelf: breakpoint <= Breakpoint.Small ? 'self-start' : 'initial'
});